module.exports = __webpack_public_path__ + "img/2906274.056cb9d.svg";